import { Font } from '@react-pdf/renderer';
import { LANGUAGE_CODE, getCurrentLocale } from 'utils/intl';

const FONTS = {
  NOTO_SANS_JP: 'NotoSansJP',
  NOTO_SANS_CN: 'NotoSansCN',
  NOTO_SANS: 'NotoSans',
};

// Construct the static assets path properly
const getStaticFontPath = () => {
  const publicUrl = import.meta.env.VITE_PUBLIC_URL || '';
  // Remove trailing slash if present
  const cleanPublicUrl = publicUrl.replace(/\/$/, '');
  // Add /static to the end
  return `${cleanPublicUrl}/static/font`;
};

const STATIC_PATH = getStaticFontPath();

export const registerFontsForLanguage = (language) => {
  switch (language) {
    case LANGUAGE_CODE.JAPANESE:
      Font.register({
        family: FONTS.NOTO_SANS_JP,
        fonts: [
          {
            src: `${STATIC_PATH}/Noto_Sans_JP/static/NotoSansJP-Regular.ttf`,
            fontWeight: 'normal',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans_JP/static/NotoSansJP-Bold.ttf`,
            fontWeight: 'bold',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans_JP/static/NotoSansJP-Light.ttf`,
            fontWeight: 'light',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans_JP/static/NotoSansJP-Medium.ttf`,
            fontWeight: 'medium',
          },
        ],
      });
      break;
    case LANGUAGE_CODE.CHINESE:
      Font.register({
        family: FONTS.NOTO_SANS_CN,
        fonts: [
          {
            src: `${STATIC_PATH}/Noto_Sans_SC/static/NotoSansSC-Regular.ttf`,
            fontWeight: 'normal',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans_SC/static/NotoSansSC-Bold.ttf`,
            fontWeight: 'bold',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans_SC/static/NotoSansSC-Light.ttf`,
            fontWeight: 'light',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans_SC/static/NotoSansSC-Medium.ttf`,
            fontWeight: 'medium',
          },
        ],
      });
      break;
    case LANGUAGE_CODE.ENGLISH:
    case LANGUAGE_CODE.INDONESIAN:
      Font.register({
        family: FONTS.NOTO_SANS,
        fonts: [
          {
            src: `${STATIC_PATH}/Noto_Sans/static/NotoSans-Regular.ttf`,
            fontWeight: 'normal',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans/static/NotoSans-Bold.ttf`,
            fontWeight: 'bold',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans/static/NotoSans-Italic.ttf`,
            fontWeight: 'normal',
            fontStyle: 'italic',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans/static/NotoSans-BoldItalic.ttf`,
            fontWeight: 'bold',
            fontStyle: 'italic',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans/static/NotoSans-Light.ttf`,
            fontWeight: 'light',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans/static/NotoSans-Medium.ttf`,
            fontWeight: 'medium',
          },
        ],
      });
      break;
    default:
      Font.register({
        family: FONTS.NOTO_SANS,
        fonts: [
          {
            src: `${STATIC_PATH}/Noto_Sans/static/NotoSans-Regular.ttf`,
            fontWeight: 'normal',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans/static/NotoSans-Bold.ttf`,
            fontWeight: 'bold',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans/static/NotoSans-Italic.ttf`,
            fontWeight: 'normal',
            fontStyle: 'italic',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans/static/NotoSans-BoldItalic.ttf`,
            fontWeight: 'bold',
            fontStyle: 'italic',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans/static/NotoSans-Light.ttf`,
            fontWeight: 'light',
          },
          {
            src: `${STATIC_PATH}/Noto_Sans/static/NotoSans-Medium.ttf`,
            fontWeight: 'medium',
          },
        ],
      });
      break;
  }
};

// Get the appropriate font family based on current language
export const getFontFamilyForLanguage = (language) => {
  switch (language) {
    case LANGUAGE_CODE.JAPANESE:
      return FONTS.NOTO_SANS_JP;
    case LANGUAGE_CODE.CHINESE:
      return FONTS.NOTO_SANS_CN;
    case LANGUAGE_CODE.ENGLISH:
    case LANGUAGE_CODE.INDONESIAN:
    default:
      return FONTS.NOTO_SANS;
  }
};
